declare global {
    interface Window {
        __PG_RP_DATA_LAYER_PUSH_DEFERRED__?: boolean;
    }
}

export const deferDataLayerPushAfterLoad = (): void => {
    if (process.env.EXEC_ENV !== "browser" || typeof window === "undefined") {
        return;
    }

    const win = window as Window;

    if (win.__PG_RP_DATA_LAYER_PUSH_DEFERRED__) {
        return;
    }

    win.__PG_RP_DATA_LAYER_PUSH_DEFERRED__ = true;

    const installDeferredPush = () => {
        win.dataLayer = win.dataLayer || [];

        const dataLayer = win.dataLayer;
        const originalDataLayerPush = dataLayer.push;
        const pendingPushes = new Set<object[]>();

        const runPush = (args: object[]) => {
            if (!pendingPushes.delete(args)) {
                // already flushed
                return;
            }

            originalDataLayerPush.apply(dataLayer, args);
        };

        /**
         * Without this, a push deferred by the click that also navigates away never reaches the
         * dataLayer - the frame it was waiting for never happens. That is how the first round of this
         * optimisation could silently drop events
         */
        const flushPendingPushes = () => {
            if (pendingPushes.size === 0) {
                return;
            }

            const pushes = Array.from(pendingPushes);
            pendingPushes.clear();
            pushes.forEach((args) => originalDataLayerPush.apply(dataLayer, args));
        };

        win.addEventListener("pagehide", flushPendingPushes);
        document.addEventListener("visibilitychange", () => {
            if (document.visibilityState === "hidden") {
                flushPendingPushes();
            }
        });

        dataLayer.push = (...args: object[]) => {
            /**
             * A hidden page gets no animation frames, so deferring would park the push until the tab
             * is shown again - or drop it entirely if the page goes away. This also covers pushes
             * emitted by flush handlers during pagehide/visibilitychange: those must not re-enter
             * the deferred queue after it has already been flushed.
             */
            if (document.visibilityState === "hidden") {
                originalDataLayerPush.apply(dataLayer, args);

                return dataLayer.length;
            }

            pendingPushes.add(args);

            requestAnimationFrame(() => {
                setTimeout(() => {
                    runPush(args);
                }, 0);
            });

            return dataLayer.length;
        };
    };

    if (document.readyState === "complete") {
        installDeferredPush();
        return;
    }

    win.addEventListener("load", installDeferredPush, {once: true});
};
declare global {
    interface Window {
        __PG_RP_DATA_LAYER_PUSH_DEFERRED__?: boolean;
    }
}

export const deferDataLayerPushAfterLoad = (): void => {
    if (process.env.EXEC_ENV !== "browser" || typeof window === "undefined") {
        return;
    }

    const win = window as Window;

    if (win.__PG_RP_DATA_LAYER_PUSH_DEFERRED__) {
        return;
    }

    win.__PG_RP_DATA_LAYER_PUSH_DEFERRED__ = true;

    const installDeferredPush = () => {
        win.dataLayer = win.dataLayer || [];

        const dataLayer = win.dataLayer;
        const originalDataLayerPush = dataLayer.push;
        const pendingPushes = new Set<object[]>();

        const runPush = (args: object[]) => {
            if (!pendingPushes.delete(args)) {
                // already flushed
                return;
            }

            originalDataLayerPush.apply(dataLayer, args);
        };

        /**
         * Without this, a push deferred by the click that also navigates away never reaches the
         * dataLayer - the frame it was waiting for never happens. That is how the first round of this
         * optimisation could silently drop events
         */
        const flushPendingPushes = () => {
            if (pendingPushes.size === 0) {
                return;
            }

            const pushes = Array.from(pendingPushes);
            pendingPushes.clear();
            pushes.forEach((args) => originalDataLayerPush.apply(dataLayer, args));
        };

        win.addEventListener("pagehide", flushPendingPushes);
        document.addEventListener("visibilitychange", () => {
            if (document.visibilityState === "hidden") {
                flushPendingPushes();
            }
        });

        dataLayer.push = (...args: object[]) => {
            /**
             * A hidden page gets no animation frames, so deferring would park the push until the tab
             * is shown again - or drop it entirely if the page goes away. This also covers pushes
             * emitted by flush handlers during pagehide/visibilitychange: those must not re-enter
             * the deferred queue after it has already been flushed.
             */
            if (document.visibilityState === "hidden") {
                originalDataLayerPush.apply(dataLayer, args);

                return dataLayer.length;
            }

            pendingPushes.add(args);

            requestAnimationFrame(() => {
                setTimeout(() => {
                    runPush(args);
                }, 0);
            });

            return dataLayer.length;
        };
    };

    if (document.readyState === "complete") {
        installDeferredPush();
        return;
    }

    win.addEventListener("load", installDeferredPush, {once: true});
};
